import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { primaryColor, green } from '~theme';

const propTypes = {
  isToggled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

const ToggleButton = ({ onToggle, isToggled, label }) => (
  <Wrapper onClick={onToggle}>
    <Slider isToggled={isToggled}>
      <Ball />
    </Slider>
    <Label>
      {label} {isToggled ? 'päällä' : 'pois päältä'}
    </Label>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Label = styled.div`
  font-size: 14px;
  color: #fff;
`;

const Ball = styled.div`
  border-radius: 50%;
  background-color: #fff;
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
`;

const Slider = styled.div`
  height: 28px;
  width: 50px;
  min-width: 50px;
  display: flex;
  align-items: center;

  background-color: ${props => (props.isToggled ? green : primaryColor)};

  padding: 0 4px;
  margin-right: 12px;
  border: 1px solid #fff;
  border-radius: 9999px;
  cursor: pointer;
  &:hover {
    ${Ball} {
      transform: scale(1.1);
    }
  }

  ${props =>
    props.isToggled &&
    css`
      ${Ball} {
        transform: translateX(20px);
      }
      &:hover {
        ${Ball} {
          transform: translateX(20px) scale(1.1);
        }
      }
    `}
`;

ToggleButton.propTypes = propTypes;

export default ToggleButton;
